import { render, staticRenderFns } from "./FreeGptMobile.vue?vue&type=template&id=5a258634&scoped=true"
import script from "./FreeGptMobile.vue?vue&type=script&lang=js"
export * from "./FreeGptMobile.vue?vue&type=script&lang=js"
import style0 from "./FreeGptMobile.vue?vue&type=style&index=0&id=5a258634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a258634",
  null
  
)

export default component.exports